/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-block-editor/#useBlockProps
 */
 import { useBlockProps } from '@wordpress/block-editor';
// import { hot } from 'react-hot-loader' 
// import screenfull from 'screenfull';
// import Duration from './Duration';

/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#save
 *
 * @return {WPElement} Element to render.
 */
export default function save({ className, attributes }) {
    const { url, pip, playing, controls, light, volume, muted, played, loaded, duration, playbackRate, loop } = attributes
	return (
		<div { ...useBlockProps.save() }>
            <div className='blockplayer-main-area' data-play={JSON.stringify(attributes)}></div>
		</div>
	);
}